import Vue from 'vue'
export  const notify = (title) => {
  Vue.notify({
    group: 'mgs',
    type: 'success',
    title: title,
    timestamp: 5000
  })
}